import update from "immutability-helper";
import { findIndex as _findIndex } from "lodash-es";

import { CREATE_EVENT, DELETE_EVENT, UPDATE_EVENT } from "../actions/events";
import { UPDATE_HUMAN_TAGS } from "../actions/humans";
import { FETCH_UPDATES_SUCCESS, SET_PENDING, SET_SAVED } from "../actions/sync";
import {
  makeHumanTagChecker,
  makeHumanTagNameSlugUpdater,
  makeObjectsSaved,
  setPendingFlag,
  updateFromFetchUpdates,
} from "../utils";

const updateHumanTagsInEvents = (events, humanId, newName) => {
  const checkHasTag = makeHumanTagChecker(humanId);
  const updateSlugs = makeHumanTagNameSlugUpdater(humanId, newName);

  return events.map((event) => {
    if (!checkHasTag(event.label)) return event;

    return {
      ...event,
      label: updateSlugs(event.label),
      modified: true,
    };
  });
};

export default function events(state = [], action) {
  switch (action.type) {
    case CREATE_EVENT: {
      return [
        ...state,
        {
          id: action.id,
          humanId: action.humanId,
          date: action.date,
          label: action.label,
          createdAt: new Date().toISOString(),
          modifiedAt: new Date().toISOString(),
          pending: false,
          modified: true,
        },
      ];
    }

    case UPDATE_EVENT: {
      const i = _findIndex(state, { id: action.id });
      if (i < 0) return state;

      if (action.obj.modified) {
        action.obj.modifiedAt = new Date().toISOString();
      }

      return update(state, { [i]: { $merge: action.obj } });
    }

    case SET_PENDING: {
      return setPendingFlag(state, action.data.event, action.pending);
    }

    case SET_SAVED: {
      return makeObjectsSaved(state, action.data.event);
    }

    case FETCH_UPDATES_SUCCESS: {
      return updateFromFetchUpdates(state, action.payload.data.events);
    }

    case DELETE_EVENT: {
      const eventIndex = _findIndex(state, { id: action.id });
      return update(state, { $splice: [[eventIndex, 1]] });
    }

    case UPDATE_HUMAN_TAGS: {
      return updateHumanTagsInEvents(state, action.humanId, action.newName);
    }

    default:
      return state;
  }
}
